import {useToast} from "vue-toastification";

function toastPop(msg, type = 'error') {
    const toast = useToast();
    switch (type) {
        case 'info':
            toast.info(msg, {timeout: 3000});
            break;
        default:
            toast.error(msg, {timeout: false});
    }
}

export default {
    errorMsg(error, type = 'error') {
        const data = error.response?.data ?? {};
        const erro = data.message;

        if (erro) {
            toastPop(erro, type);
        } else {
            const erro = data.validations?.errors ?? data.errors;

            if (!erro || erro.sql || erro.length === 0) {
                toastPop(data.validations?.message ?? 'Não foi possível concluir a operação.', type);
            } else if (erro.msg) {
                if (Array.isArray(erro.msg)) {
                    erro.msg.forEach(msg => toastPop(msg, type));
                } else {
                    const msg = erro.msg?.msg;
                    msg ? toastPop(msg, type) : toastPop(erro.msg, type);
                }
            } else {
                collectMessages(erro).forEach(msg => toastPop(msg, type));
            }
        }
    },
}

const MAX_TOASTS = 5;
const MAX_MESSAGE_LENGTH = 300;
const FALLBACK_MESSAGE = 'Não foi possível concluir a operação.';

// Aceita mensagens como string, lista ou objeto {campo: [mensagens]} sem iterar caracteres de uma string
function collectMessages(errors) {
    const values = typeof errors === 'string' ? [errors] : Object.values(errors).flat(Infinity);
    const messages = values
        .filter(value => typeof value === 'string' && value.trim() !== '')
        .map(sanitizeMessage);
    const unique = [...new Set(messages)];

    return unique.length ? unique.slice(0, MAX_TOASTS) : [FALLBACK_MESSAGE];
}

function sanitizeMessage(message) {
    if (/<!doctype|<html|<head|<body/i.test(message)) {
        return FALLBACK_MESSAGE;
    }
    const text = message.trim();

    return text.length > MAX_MESSAGE_LENGTH ? `${text.slice(0, MAX_MESSAGE_LENGTH)}…` : text;
}